export enum QueryTag {
  CurrentUser = 'CurrentUser',
  Account = 'Account',
  AdminUser = 'AdminUser',
  AdminUsers = 'AdminUsers',
  AdminProfile = 'AdminProfile',
  AdminProfiles = 'AdminProfiles',
  AdminOrganization = 'AdminOrganization',
  AdminOrganizations = 'AdminOrganizations',
  AdminInterest = 'AdminInterest',
  AdminIndustry = 'AdminIndustry',
  AdminBusinessFunction = 'AdminBusinessFunction',
  AdminQuartrEventTranscript = 'AdminQuartrEventTranscript',
  Request = 'Request',
  ClientRequest = 'ClientRequest',
  CreditTransaction = 'CreditTransaction',
  EvaluationRun = 'EvaluationRun',
  EvaluationMetric = 'EvaluationMetric',
  AdminDashboard = 'AdminDashboard',
  AdminValueDashboard = 'AdminValueDashboard',
  ProfileDetail = 'ProfileDetail',
  OrganizationDetail = 'OrganizationDetail',
  TrackedSubject = 'TrackedSubject',
  SubjectChangeEvent = 'SubjectChangeEvent',
  SubscriptionSummary = 'SubscriptionSummary',
}
